<template>
<v-footer height="auto" v-if="mini == false" class="transparent-bg">
    <v-card class="flex transparent-bg" flat tile>
        <!-- <v-card-title class="teal">
            <strong class="subheading">Get connected with us on social networks!</strong>
            <v-spacer></v-spacer>

            <v-btn v-for="icon in icons" :key="icon" class="mx-2" dark icon>
                <v-icon size="24px">{{ icon }}</v-icon>
            </v-btn>
        </v-card-title> -->

        <v-card-actions class="justify-center font-size">
            2019&copy;<strong>{{ getCompanyName }}</strong>
        </v-card-actions>
    </v-card>
</v-footer>
</template>

<script>
export default {
    name: "Footer",
    props: ["options"],
    data() {
        return {
            mini: this.options,
            icons: [
                "fab fa-facebook",
                "fab fa-twitter",
                "fab fa-google-plus",
                "fab fa-linkedin",
                "fab fa-instagram"
            ]
        }
    },
    watch: {
        options(newValue) {
            return this.mini = newValue;
        }
    },
    computed: {
        getCompanyName: function() {
            return this.$store.getters.system_name === '' ? 'Webot' : this.$store.getters.system_name;
        }
    }
}
</script>

<style scoped>
.font-size {
    font-size: 12px;
}
</style>
